/* src/home/StartUps.jsx */
import React, { Component, createRef } from "react";
import { Helmet } from 'react-helmet';
import HeaderOne from '../components/header/HeaderOne';
import TabsThree from "../elements/component/tabs/TabsThree";
import CardContentSlider from '../components/CardSwiper';
import CalltoActionFour from "../elements/component/callto-action/CalltoActionFour";
import Wavify from '../components/plugins/WavifyWhite';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import StackedCarousel from '../components/StackedCarousel';
import Footer from '../components/footer/Footer';
import CardSwiper from "../components/CardSwiper";
// Import preview images
const previewImg1 = require('../assets/images/eidocell/eidocell_preview_1.jpeg');
const previewImg2 = require('../assets/images/eidocell/eidocell_preview_2.jpeg');
const previewImg3 = require('../assets/images/eidocell/eidocell_preview_3.jpeg');

const previewImages = [previewImg1, previewImg2, previewImg3];

const eidocellFeatures = [
    // ... (feature data remains the same)
    {
        id: 1,
        title: "Image Management & Organization",
        image: require('../assets/images/eidocell/features/gallery_view.png'),
        description: "Efficiently import, organize, and browse large datasets of images. Manage sessions and tag images with custom classes."
    },
    {
        id: 2,
        title: "Advanced Segmentation",
        image: require('../assets/images/eidocell/features/segmentation_view.png'),
        description: "Use various segmentation algorithms (Otsu, Watershed, AI models) with adjustable parameters for precise cell boundary detection. Preview results in real-time."
    },
    {
        id: 3,
        title: "Feature Extraction",
        image: require('../assets/images/eidocell/features/feature_extraction.png'),
        description: "Extract a wide range of morphological, intensity, and textural features using pre-trained or custom ONNX models (e.g., DINOv2, MobileNet)."
    },
    {
        id: 4,
        title: "Intelligent Clustering & Classification",
        image: require('../assets/images/eidocell/features/clustering_view.png'),
        description: "Group similar cells based on their features using K-means or other clustering techniques. Assign cells to user-defined classes for supervised analysis."
    },
    {
        id: 5,
        title: "Data Visualization & Analysis",
        image: require('../assets/images/eidocell/features/analysis_view.png'),
        description: "Generate interactive plots (histograms, scatter plots) to explore feature distributions and relationships. Apply gates for custom filtering."
    },
    {
        id: 6,
        title: "Extensibility & Open Source",
        image: require('../assets/images/eidocell/features/github_logo.png'),
        description: "Built on Python and Qt, Eidocell is open-source and welcomes contributions."
    }
];

export default class StartUps extends Component {
    textColRef     = createRef();    // left / upper column
    carColRef      = createRef();    // right / lower column
    containerTimer = null;
  
    state = { carMarginTop: 0 };
  
    /* ---------------------------------------------------------------- mount */
    componentDidMount() {
      this.adjustMargin();
      window.addEventListener("resize",         this.debouncedAdjust);
      window.addEventListener("orientationchange", this.debouncedAdjust);
    }
  
    componentWillUnmount() {
      clearTimeout(this.containerTimer);
      window.removeEventListener("resize",         this.debouncedAdjust);
      window.removeEventListener("orientationchange", this.debouncedAdjust);
    }
  
    debouncedAdjust = () => {
      clearTimeout(this.containerTimer);
      this.containerTimer = setTimeout(this.adjustMargin, 100);
    };
  
    /* --------------------------------------------------- core measurement */
    adjustMargin = () => {
      const txtCol = this.textColRef.current;
      const carCol = this.carColRef.current;
      if (!txtCol || !carCol) return;
  
      /* actual heights */
      const txtH = txtCol.getBoundingClientRect().height;
      const carH = carCol
        .querySelector(".stacked-carousel-container")
        .getBoundingClientRect().height;
  
      const diff = carH - txtH;          // positive when carousel is taller
      const needed = diff > 0 ? Math.ceil(diff / 2) + 1 : 0; // half the excess + buffer
  
      if (needed !== this.state.carMarginTop) {
        this.setState({ carMarginTop: needed });
      }
    };
  
    /* ====================================================================== */
    render() {
      return (
        <>
          <Helmet>
            <title>Eidocell</title>
            <meta
              name="description"
              content="Powerful open source platform for single‑cell image analysis."
            />
          </Helmet>
  
          <HeaderOne />
  
          {/* ================================================= HERO */}
          <div className="slider-area">
            <div
              className="single-slide slider--startups bg_image fullscreen d-flex flex-column"
              style={{
                backgroundImage: `url(${require("../assets/images/eidocell/gradient_background.png")})`
              }}
            >
              <div className="container flex-grow-1">
                <div className="row align-items-lg-center">
                  {/* ---------------- TEXT COLUMN */}
                  <div
                    ref={this.textColRef}
                    className="col-lg-5 d-flex flex-column justify-content-center hero-text-column"
                  >
                    <div className="slider-content">
                      <div className="inner">
                        <h1 className="text-white title hero-title">Eidocell - single image analysis platform</h1>
                        <p className="text-white font--18 description hero-description">
                          Efficiently analyse cytometry images with modern machine
                          learning approaches and an intuitive UI.
                          <p className="text-white font--18 description hero-warning">This is an early experimental version.</p>
                        </p>
  
                        <div className="button-group d-flex flex-row flex-wrap justify-content-start mt-3 mb-3 hero-buttons">
                          <button
                            className="ar-button style-flat secondary me-2 mb-2"
                            onClick={() => window.open("https://github.com/xuzzu/eidocell", "_blank", "noopener,noreferrer")}
                          >
                            <span className="button-text">Visit GitHub Page</span>
                          </button>
                          {/* <button className="ar-button style-flat secondary me-2 mb-2">
                            <span className="button-text">Download for Mac</span>
                          </button> */}
                          {/* <button className="ar-button style-flat secondary mb-2">
                            <span className="button-text">Download for Linux</span>
                          </button> */}
                          {/* <p className="text-white font--14 opacity-75 hero-disclaimer mt-2">
                          Note: This is an early experimental version.
                         </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
  
                  {/* ---------------- CAROUSEL COLUMN */}
                  <div
                    ref={this.carColRef}
                    className="col-lg-7 d-flex align-items-center justify-content-center hero-carousel-column"
                    style={{ marginTop: this.state.carMarginTop }}
                  >
                    <div className="thumbnail w-100 h-100 d-flex align-items-center justify-content-center">
                      <StackedCarousel images={previewImages} />
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="wavify-position">
                <Wavify />
              </div>
            </div>
          </div>
  
          {/* ============================================== FEATURES */}
          <div className="eidocell-features-area pt--80 pb--120 bg_color--1">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center mb--60">
                    <h2 className="text-white">Core Features of Eidocell</h2>
                    {/* <p className="text-white">
                      Discover how Eidocell empowers your single‑cell image
                      analysis workflow.
                    </p> */}
                  </div>
                </div>
              </div>
  
              <div className="row justify-content-center">
                {eidocellFeatures.map((f) => (
                  <div className="col-lg-4 col-md-6 col-sm-12 mb--40" key={f.id}>
                    <div className="eidocell-feature-block text-center">
                      <div className="thumbnail mb--30">
                        <img
                          src={f.image}
                          alt={f.title}
                          className="img-fluid rounded"
                        />
                      </div>
                      <h3 className="text-white h5 mb--15">{f.title}</h3>
                      <p className="text-white opacity-75">{f.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
  
          {/* ================================================ TABS */}
          {/* <div className="our-tabs-area startups-tabstwo-area pt--120 pb--20">
            <CardSwiper />
          </div> */}
  
          <Footer />
  
          {/* ------------------------------------------------ back‑to‑top */}
          <div className="backto-top">
            <ScrollToTop showUnder={160}>
              <FiChevronUp />
            </ScrollToTop>
          </div>
        </>
      );
    }
  }